module.exports = __webpack_public_path__ + "static/media/Untitled.629b123e.png";